import { useParams } from "react-router-dom";
import { AuthView } from "@daveyplate/better-auth-ui";
import { Box } from "@mui/material";

export default function AuthPage() {
  const { pathname } = useParams<{ pathname: string }>();

  return (
    <Box
      sx={{
        minHeight: "100vh",
        position: "relative",
        overflow: "hidden",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#0a0a0a",
      }}
    >
      {/* Gradient background */}
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          marginTop: 0,
          opacity: 1,
        }}
      >
        <Box
          sx={{
            position: "absolute",
            left: "50%",
            top: "20%",
            aspectRatio: "1/1",
            width: {
              xs: "350%",
              md: "190%",
              lg: "190%",
              xl: "190%",
              "2xl": "190%",
            },
            transform: "translateX(-50%)",
            overflow: "hidden",
            backgroundImage: "url('/gradientBackground.svg')",
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center top",
            mask: "linear-gradient(transparent 0%, black 5%, black 100%)",
            WebkitMask: "linear-gradient(transparent 0%, black 5%, black 100%)",
            backfaceVisibility: "hidden",
          }}
        />
      </Box>

      {/* Grain texture overlay */}
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          backgroundImage: "url('/grain.1ccdda41.png')",
          backgroundSize: "100px 100px",
          backgroundRepeat: "repeat",
          backgroundBlendMode: "overlay",
          backgroundPosition: "left top",
          mixBlendMode: "overlay",
        }}
      />

      {/* Auth View Content */}
      <Box
        sx={{
          position: "relative",
          zIndex: 10,
          width: "100%",
          maxWidth: { xs: 400, sm: 480 },
          mx: { xs: 2, sm: 3 },
        }}
      >
        <AuthView pathname={pathname} />
      </Box>
    </Box>
  );
}
